var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTableFeature = function SvgTableFeature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.088 36.264 36.264.088H.088v36.176Z",
    fill: "#FCB281"
  })));
};
export default SvgTableFeature;